import type { InteractiveComponent } from 'fe-be-utils';
import { DatePickerComponent } from './DatePickerComponent';
import { AddressInputComponent } from './AddressInputComponent';
import { OptionsComponent } from './OptionsComponent';

type InteractiveComponentRendererProps = {
  component: InteractiveComponent;
  onSubmit: (value: string) => void;
  onDismiss: () => void;
  accentColor?: string;
  textOverAccentColor?: string;
  chatId?: string;
};

export const InteractiveComponentRenderer = ({
  component,
  onSubmit,
  onDismiss,
  accentColor,
  textOverAccentColor,
  chatId
}: InteractiveComponentRendererProps) => {
  switch (component.type) {
    case 'date_picker':
      return (
        <DatePickerComponent
          params={component.params}
          onSubmit={onSubmit}
          onDismiss={onDismiss}
          accentColor={accentColor}
          textOverAccentColor={textOverAccentColor}
        />
      );
    case 'address_input':
      return (
        <AddressInputComponent
          params={component.params}
          onSubmit={onSubmit}
          onDismiss={onDismiss}
          accentColor={accentColor}
          textOverAccentColor={textOverAccentColor}
          chatId={chatId}
        />
      );
    case 'options':
      return (
        <OptionsComponent
          params={component.params}
          onSubmit={onSubmit}
          onDismiss={onDismiss}
          accentColor={accentColor}
          textOverAccentColor={textOverAccentColor}
        />
      );
  }
};
